var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21 16.2896C8.06974 16.2893 7.93603 16.2302 7.8415 16.1266C7.74522 16.0238 7.69738 15.8848 7.71 15.7446L7.8325 14.3976L13.4915 8.74057L15.26 10.5086L9.6025 16.1651L8.2555 16.2876C8.24 16.2891 8.2245 16.2896 8.21 16.2896ZM15.613 10.1551L13.845 8.38707L14.9055 7.32657C14.9993 7.23269 15.1265 7.17993 15.2592 7.17993C15.392 7.17993 15.5192 7.23269 15.613 7.32657L16.6735 8.38707C16.7674 8.48086 16.8201 8.60812 16.8201 8.74082C16.8201 8.87353 16.7674 9.00079 16.6735 9.09458L15.6135 10.1546L15.613 10.1551Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.e7fd4030.svg";
export { ForwardRef as ReactComponent };